import { dummyGames } from "../../data/dummyGames";

export async function allGames() {
  return Promise.resolve(dummyGames);
}
